import {SettingsState} from '../reducers/settings.reducer';

export const selectSettings = (state): SettingsState => state.get('settings').toJS();
